/**
 * Store permettant de gérer les toggle view chrono ou classique d'affichage dans les différents menus
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ingouvernance: false,
  insocial: false,
  inviews: false,
  inspace: false,
};

export const ReduxToggleSlice = createSlice({
  name: "ReduxToggle",
  initialState,
  reducers: {
    chgGovernanceToggle: (state, action) => {
      state.ingouvernance = action.payload;
    },
    chgSocialToggle: (state, action) => {
      state.insocial = action.payload;
    },
    chgSpaceToggle: (state, action) => {
      state.inspace = action.payload;
    },
    chgInviewsToggle: (state, action) => {
      state.inviews = action.payload;
    },
    chgOperationToggle: (state, action) => {
      state.inoperation = action.payload;
    },
  },
});

export const {
  chgGovernanceToggle,
  chgSocialToggle,
  chgInviewsToggle,
  chgSpaceToggle,
  chgOperationToggle,
} = ReduxToggleSlice.actions;

export const selectInGouvernanceToggle = (state) => state.ReduxToggle.ingouvernance;
export const selectInOperationToggle = (state) => state.ReduxToggle.inoperation;
export const selectInSocialToggle = (state) => state.ReduxToggle.insocial;
export const selectInViewsToggle = (state) => state.ReduxToggle.inviews;
export const selectSpaceToggle = (state) => state.ReduxToggle.inspace;

export default ReduxToggleSlice.reducer;
